import fetch from '../utils/fetch'

//获取问卷详情
export const fetchQuestionDetails = (params) =>
  fetch(`/web/questionnaire`, {
    params,
  })

//保存。发布问卷
export const fetchSaveQuestion = (data) =>
  fetch(`/web/questionnaire`, {
    method: 'put',
    data,
  })

//问卷列表
export const fetchQuestionList = (params) =>
  fetch(`/web/questionnaire/list`, {
    params,
  })

//获取用户填写的问卷
export const fetchUserAnswer = (recordNo) =>
  fetch(`/web/questionnaire/user/${recordNo}`)
